import {Component, Input, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {
  MSG_OBG_AUTOR_REQUERENTE,
  MSG_OBG_NUM_PROCESSO_VALIDO,
  MSG_OBG_PARTE_REQUERENTE
} from 'src/app/tools/Mensagens';
import {AplicarRegraCampos} from '../validators/aplicar-regra-campos';
import {CampoObrigatorio} from '../validators/campo-obrigatorio';
import {
  PropriaParteRequerimentoGeralComponent
} from './propria-parte-requerimento-geral/propria-parte-requerimento-geral.component';
import {
  PeloAdvogadoRequerimentoGeralComponent
} from './pelo-advogado-requerimento-geral/pelo-advogado-requerimento-geral.component';
import {
  ParteInformacaoRequerenteComponent
} from "../shared/parte-informacao-requerente/parte-informacao-requerente.component";
import {CpeResponseDTO} from "../../../../componentes/cpe-operador/dto/CpeResponseDTO";

@Component({
  selector: 'app-requerimento-geral',
  templateUrl: './requerimento-geral.component.html',
  styleUrls: ['./requerimento-geral.component.css']
})
export class RequerimentoGeralComponent implements OnInit, OnDestroy {

  @Input() formulario: FormGroup;
  @Input() somenteLeitura: boolean = false;
  @Input() dados: CpeResponseDTO;
  @ViewChild(PropriaParteRequerimentoGeralComponent, {static: false}) propriaParteRequerimentoGeral: PropriaParteRequerimentoGeralComponent;
  @ViewChild(PeloAdvogadoRequerimentoGeralComponent, {static: false})
  peloAdvogadorRequerimentoGeral: PeloAdvogadoRequerimentoGeralComponent;
  @ViewChild(ParteInformacaoRequerenteComponent, {static: false}) parteInformacaoRequerenteComponent: ParteInformacaoRequerenteComponent;


  mostrarSessaoParte = false;
  mostrarSessaoAdvogado = false;
  protected processoPossuiErro = false;

  constructor(private formBuilder: FormBuilder) {
  }

  ngOnInit() {
    if (!this.somenteLeitura) {
      const valorInicialAutor = this.dados && this.dados.informacaoRequerenteAutor ? this.dados.informacaoRequerenteAutor : null;
      this.getFormularioRequerimentoGeral().addControl('informacaoRequerenteAutor', new FormControl(valorInicialAutor, Validators.required));

      this.getFormularioRequerimentoGeral().addControl('parteInformacaoRequerente', this.formBuilder.group({}));
      this.getFormularioRequerimentoGeral().addControl('advogadoInformacaoRequerente', this.formBuilder.group({}));
    }
    if (this.dados !== null && this.dados !== undefined) {
      this.mostrarSessaoPorTipoSelecionado(this.dados.informacaoRequerenteAutor);
    }
  }

  ngOnDestroy() {
    if (!this.somenteLeitura) {
      this.getFormularioRequerimentoGeral().removeControl('informacaoRequerenteAutor');
      this.getFormularioRequerimentoGeral().removeControl('parteInformacaoRequerente');
      this.getFormularioRequerimentoGeral().removeControl('advogadoInformacaoRequerente');
    }
  }

  protected getFormularioRequerimentoGeral() {
    return this.formulario.get('requerimentoGeral') as FormGroup;
  }

  protected mostrarSessaoPorTipoSelecionado(tipo: string) {
    if(tipo === null) {
      this.mostrarSessaoParte = false;
      this.mostrarSessaoParte = false;
    } else if (tipo === 'parte') {
      this.mostrarSessaoParte = true;
      this.mostrarSessaoAdvogado = false;
    }else {
      this.mostrarSessaoAdvogado = true;
      this.mostrarSessaoParte = false;
    }
  }

  protected setProcessoPossuiErro($possui: boolean) {
    this.processoPossuiErro = $possui;
  }

  validarFormulario() {
    const campos = [
      {control: 'numeroProcesso', mensagem: MSG_OBG_NUM_PROCESSO_VALIDO, regra: this.validarNumeroProcesso.bind(this)},
      {control: 'informacaoRequerenteAutor', mensagem: MSG_OBG_AUTOR_REQUERENTE, regra: this.validarAutor.bind(this)},
    ];

    AplicarRegraCampos.aplicar(campos, this.getFormularioRequerimentoGeral());

    if (this.getFormularioRequerimentoGeral().get('informacaoRequerenteAutor').value === 'parte') {
      this.validarFormularioPropriaParte();
    } else {
      this.validarFormularioPeloAdvogado();
    }
    this.validarInformacoesRequerente();
  }

  private validarNumeroProcesso(value: any): boolean {
    return value != null && value !== '' && !this.processoPossuiErro;
  }

  private validarAutor(value: any): boolean {
    return CampoObrigatorio.aplicar(value);
  }

  private validarFormularioPropriaParte() {
    if (this.propriaParteRequerimentoGeral) {
      this.propriaParteRequerimentoGeral.validarFormulario();
    }
  }

  private validarFormularioPeloAdvogado() {
    if (this.peloAdvogadorRequerimentoGeral) {
      this.peloAdvogadorRequerimentoGeral.validarFormulario();
    }
  }

  private validarInformacoesRequerente() {
    if (this.parteInformacaoRequerenteComponent) {
      this.parteInformacaoRequerenteComponent.validarFormulario();
    }
  }
}
